export const options =
{
    hour: "2-digit",
    minute: "2-digit",
}
